<template>
  <div class="w-full">
    <section v-for='([layer, transforms]) in transformsByZindex' :key='layer'>
      <h2 class="font-semibold tracking-tight text-gray-200 bg-black rounded m-1">{{layer}}</h2>
      <ul class="flex flex-row flex-wrap">
        <li v-for='transform in transforms' :key='transform.id' class="my-2 mx-1 flex flex-row" :class='makeTransformClasses(transform)'>
          <div @click='select(transform)' class="cursor-pointer">
            <inline-render class="w-16 h-16"
                          :transform='transform'
                          :from='transformsAndSource.from'
                          :gamedata='transformsAndSource.gamedata'
                          :source='transformsAndSource.source'
                          :background-color='bgcolor' />
          </div>
          <div class="flex flex-col h-full justify-around">
            <pbc-button class="bg-white" @click='layerUp(transform)'>
              <arrow-up class="mx-auto" :size='20' />
            </pbc-button>
            <p class="text-black text-xs p-1 underline cursor-pointer">{{transform.transform.layer}}</p>
            <pbc-button class="bg-white" @click='layerDown(transform)'>
              <arrow-down class="mx-auto" :size='20' />
            </pbc-button>
          </div>
        </li>
      </ul>
    </section>


    <div class="text-lg w-full bg-white p-2">Auto Features</div>
    <div>
      <div v-for='layer in Object.values(transformsAndSource.from.layers)' :key='layer.id'>
        <p>{{layer.name}}</p>
        <layer-edit-auto-components :layer='layer' :partutil='partutil' :transforms-and-source='transformsAndSource' />
      </div>

    </div>


  </div>
</template>
<script>
import LayerEditAutoComponents from '@ui/organisms/LayerEditAutoComponents.vue';
import ArrowUp from '@icons/ArrowUp.vue';
import ArrowDown from '@icons/ArrowDown.vue';
import InlineRender from '@edit/atoms/InlineRender.vue';
import { sortBy, groupBy, toPairs } from 'lodash';
export default {
  props:{
    partutil:{
      type: Object,
      required: true
    },
    transformsAndSource:{
      type: Object,
      required: true
    },
    selections: {
      type: Object,
      required: true
    },
    indirectSelections:{
      type: Object,
      required: true
    }
  },
  data() {
    const transforms = this.partutil.findAllChildren();
    return {
      transforms,
    }
  },
  computed:{
    bgcolor() {
      if (this.transformsAndSource.gamedata.gamedata.game) {
        return this.transformsAndSource.gamedata.gamedata.game.bgcolor;
      } else {
        return '#313131';
      }
    },
    transformsByZindex() {
      let groups = toPairs(groupBy(this.transforms, (transform) => {
        return transform.transform.zIndex;
      }))
      groups = sortBy(groups, ([layer]) => {
        return parseInt(layer);
      });
      groups.reverse();
      groups = groups.map( ([layer,transforms]) => {
        layer = this.getLayerName(layer);
        return [layer, transforms];
      });
      return groups;
    }
  },
  methods:{
    layerUp(transform) {
      transform.transform.zIndex++;
      this.$emit('change', {transform});
    },
    layerDown(transform) {
      transform.transform.zIndex--;
      this.$emit('change', {transform});
    },
    getLayerName(zIndex) {
      console.log('zIndex', zIndex);
      if (zIndex == 1) {
        return 'Default Layer';
      } else {
        if (zIndex > 1) {
          return '+' + (zIndex - 1);
        } else {
          return '' + (zIndex - 1);
        }
      }
    },
    makeTransformClasses({id}) {
      if (this.selections[id] && !this.indirectSelections[id]) {
        return 'pbc-view-transform-list-selected';
      } else {
        return '';
      }
    },
    select(transform) {
      console.log('select here', transform);
      this.$emit("selections", {
        possibleSelections:[{transform}]
      });
    }
  },
  components:{
    InlineRender,
    ArrowUp,
    ArrowDown,
    LayerEditAutoComponents
  }
}
</script>
